import axios from 'axios'
import store from '../store/index'
import router from '@/router';
import {
  loading,
  apiLoading,
  glo_loading
} from '../components/loding'
import {
  MessageBox,
  Message
} from 'element-ui';
import config from './config.js'

import {
  isPCMobile
} from "@/utils/tools";

// 使用自定义的配置文件发送请求
const instance = axios.create({
  baseURL: '',
  timeout: 120000,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    'Content-Type': 'multipart/form-data;charset=UTF-8',
    // 'custome-header':'tianliangjiaoyu'
  }
});
let baseURL = config.baseURL;
let baseURL1 = config.baseURL1;
let baseURL2 = config.baseURL2;
let baseURL3 = config.baseURL3;
let baseURL4 = config.baseURL1.slice(0, -6);
// if(process.env.VUE_APP_ENV === 'dev') {
//   baseURL1 = process.env.VUE_APP_API_URL1;
//   baseURL2 = process.env.VUE_APP_API_URL2;
//   baseURL3 = process.env.VUE_APP_API_URL3;
// } else {
//   baseURL1 = process.env.VUE_APP_API_URL1;
//   baseURL2 = process.env.VUE_APP_API_URL2;
//   baseURL3 = process.env.VUE_APP_API_URL3;
// }
// 设置post的请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 添加请求拦截器
instance.interceptors.request.use(function (config) {

  // 每次发送请求之前判断vuex中是否存在token        
  // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
  // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
  // console.log(apiLoading,"apiLoading");
  // apiLoading ? glo_loading.loadingShow() : ''
  const token = store.getters.getToken;
  // debugger
  // if (token) {
  //     // 已经登录成功，统一添加token
  //     config.headers.Authorization = `Bearer ${token}`
  // }
  // console.log(config,"config");
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 这里说一下token，一般是在登录完成之后，将用户的token通过localStorage或者cookie存在本地，
// 然后用户每次在进入页面的时候（即在main.js中），会首先从本地存储中读取token，如果token存在说明用户已经登陆过，
// 则更新vuex中的token状态。然后，在每次请求接口的时候，都会在请求的header中携带token，
// 后台人员就可以根据你携带的token来判断你的登录是否过期，如果没有携带，则说明没有登录过。
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  if (response.status === 200) {
    // apiLoading ? glo_loading.loadingHide() : ''
    return Promise.resolve(response);
  } else {
    loading ? glo_loading.loadingHide() : ''
    return Promise.reject(response);
  }

}, function (error) {
  // 对响应错误做点什么
  if (error.response.status) {
    switch (error.response.status) {
      // 401: 未登录
      // 未登录则跳转登录页面，并携带当前页面的路径
      // 在登录成功后返回当前页面，这一步需要在登录页操作。                
      case 401:
        store.dispatch("logout");
        Message.warning("登录过期，请重新登录");
        store.commit("setLoginShow", 1);
        // MessageBox.confirm('登录过期，请重新登录, 是否前往登录?', '提示', {
        //   closeOnClickModal: false,
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch("logout")
        //   setTimeout(() => {
        //     // router.replace({
        //     //   path: "/"
        //     // })
        //   }, 100);
        // }).catch(() => {

        // });
        break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面                
      case 403:
        // store.dispatch("logout");
        Message.warning("无权限访问");
        // store.commit("setLoginShow", 1);
        // this.$message({
        //   message: '登录过期，请重新登录',
        //   duration: 1000,
        //   type: 'success'
        // });
        // // 清除token
        // localStorage.removeItem('token');
        // store.commit('loginSuccess', null);
        // // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 
        // store.dispatch("logout")
        // setTimeout(() => {
        //   store.commit("setLoginShow", 1);
        //   // location.href = "/";
        //   // router.replace({
        //   //   path: '/',
        //   // });
        // }, 100);
        break;

        // 404请求不存在
      case 404:
        this.$message({
          message: '网络请求不存在',
          duration: 1500,
          type: 'success'

        });
        break;
        // 405 账号在其他浏览器或终端登录
      case 405:
        store.dispatch("logout");
        Message.warning("你的账号在其他地方登录，请重新登录");
        store.commit("setLoginShow", 1);
        // MessageBox.confirm('你的账号在其他地方登录，请重新登录', '提示', {
        //   closeOnClickModal: false,
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch("logout").then(() => {
        //     store.commit("setLoginShow", 1);
        //     // location.href = "/";
        //     // router.replace({
        //     //   path: "/"
        //     // })
        //   })
        // }).catch(() => {

        // });
        break;
        // 其他错误，直接抛出错误提示
      default:
        this.$message({
          message: error.response.data.message,
          duration: 1500,
          type: 'success'

        });
    }
    return Promise.reject(error.response);
  }
});


/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    instance.get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        loading ? glo_loading.loadingHide() : ''
        reject(err.data)
      })
  });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function indexPost(url, params, headers) {
  let baseUrl = baseURL1 + url
  params = Object.assign(params || {}, {
    token: localStorage.getItem("token") || store.getters.getToken || "",
    device: isPCMobile() ? "map" : "pc",
  })
  // console.log(baseUrl,"baseUrl");
  return new Promise((resolve, reject) => {
    instance.post(baseUrl, params, headers)
      .then(res => {
        // console.log(res,"post");
        if (res.data.code == 1) {
          resolve(res.data.data);
        } else {
          // glo_loading.loadingHide()
          // Message.error(res.data.msg);
          loading ? glo_loading.loadingHide() : ''
          resolve(res.data)
        }

      })
      .catch(err => {
        loading ? glo_loading.loadingHide() : ''
        // glo_loading.loadingHide()
        reject(err.data)
      })
  });
}
export function userPost(url, params, headers) {
  let baseUrl = baseURL2 + url
  params = Object.assign(params || {}, {
    token: localStorage.getItem("token") || store.getters.getToken || "",
    device: isPCMobile() ? "map" : "pc",
  })
  return new Promise((resolve, reject) => {
    instance.post(baseUrl, params, headers)
      .then(res => {
        // console.log(res,"post");
        if (res.data.code == 1) {
          resolve(res.data.data);
        } else {
          loading ? glo_loading.loadingHide() : ''
          // glo_loading.loadingHide()
          // Message.error(res.data.msg);
          resolve(res.data)
        }
      })
      .catch(err => {
        loading ? glo_loading.loadingHide() : ''
        // glo_loading.loadingHide()
        reject(err.data)
      })
  });
}
export function basePost(url, params, headers) {
  let baseUrl = baseURL4 + url
  params = Object.assign(params || {}, {
    token: localStorage.getItem("token") || store.getters.getToken || "",
    device: isPCMobile() ? "map" : "pc",
  })
  return new Promise((resolve, reject) => {
    instance.post(baseUrl, params, headers)
      .then(res => {
        // console.log(res,"post");
        if (res.data.code == 1) {
          resolve(res.data.data);
        } else {
          loading ? glo_loading.loadingHide() : ''
          // glo_loading.loadingHide()
          // Message.error(res.data.msg);
          resolve(res.data)
        }
      })
      .catch(err => {
        loading ? glo_loading.loadingHide() : ''
        // glo_loading.loadingHide()
        reject(err.data)
      })
  });
}
export function myBasePost(url, params, headers) {
  let baseUrl = baseURL4 + url
  params = Object.assign(params || {}, {
    token: localStorage.getItem("token") || store.getters.getToken || "",
    device: isPCMobile() ? "map" : "pc",
  })
  return new Promise((resolve, reject) => {
    instance.post(baseUrl, params, headers)
      .then(res => {
        if (res.data.code == 1) {
          resolve(res.data);
        } else {
          loading ? glo_loading.loadingHide() : "";
          resolve(res.data);
        }
      })
      .catch(err => {
        loading ? glo_loading.loadingHide() : "";
        reject(err.data);
      })
  });
}
export function downloadsPost(url, params, headers) {
  let baseUrl = baseURL3 + url
  params = Object.assign(params || {}, {
    token: localStorage.getItem("token") || store.getters.getToken || "",
    device: isPCMobile() ? "map" : "pc",
  })
  return new Promise((resolve, reject) => {
    instance.post(baseUrl, params, headers)
      .then(res => {
        // console.log(res,"post");
        if (res.data.code == 1) {
          resolve(res.data.data);
        } else {
          loading ? glo_loading.loadingHide() : ''
          // Object.assign
          // glo_loading.loadingHide()
          // Message.error(res.data.msg);
          resolve(res.data)
        }

      })
      .catch(err => {
        loading ? glo_loading.loadingHide() : ''
        // glo_loading.loadingHide()
        reject(err.data)
      })
  });
}

// 手机端封装请求
export function mobileBasePost(url, params, headers) {
  let baseUrl = baseURL + url;
  params = Object.assign(params || {}, {
    token: localStorage.getItem("token") || store.getters.getToken || "",
    device: isPCMobile() ? "map" : "pc",
  });
  return new Promise((resolve, reject) => {
    instance.post(baseUrl, params, headers)
      .then(res => {
        if (res.data.code == 1) {
          resolve(res.data);
        } else {
          loading ? glo_loading.loadingHide() : "";
          resolve(res.data);
        }
      })
      .catch(err => {
        loading ? glo_loading.loadingHide() : "";
        reject(err.data);
      })
  });
}